import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateNode } from '../certification-template-editor.component';
import { CertificateValueNode, TemplateValueNodeEditorComponent } from '../template-value-node-editor/template-value-node-editor.component';

@Component({
  selector: 'app-template-value-editor',
  templateUrl: './template-value-editor.component.html',
  styleUrls: ['./template-value-editor.component.css'],
  standalone: true,
  imports: [CommonModule, TemplateValueNodeEditorComponent]
})
export class TemplateValueEditorComponent implements OnInit, OnChanges {
  /**
   * JSON string of TemplateNode[] produced by CertificationTemplateEditorComponent
   */
  @Input() shapeJson: string;

  /**
   * Optional incoming value JSON (e.g. when editing an existing certificate)
   * It will be deep-merged with the shape.
   */
  @Input() valueJson?: string;

  /**
   * Emits the current filled values as JSON string of CertificateValueNode[]
   */
  @Output() valueJsonChange = new EventEmitter<string>();

  templateNodes: TemplateNode[] = [];
  valueNodes: CertificateValueNode[] = [];

  ngOnInit() {
    this.initFromInputs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['shapeJson'] || changes['valueJson']) {
      this.initFromInputs();
    }
  }

  private initFromInputs() {
    this.templateNodes = [];
    console.log(this.shapeJson);
    if (this.shapeJson) {
      try {
        this.templateNodes = JSON.parse(this.shapeJson) as TemplateNode[];
        console.log(this.templateNodes);
      } catch {
        this.templateNodes = [];
      }
    }

    let incomingValues: CertificateValueNode[] | null = null;
    if (this.valueJson) {
      try {
        incomingValues = JSON.parse(this.valueJson) as CertificateValueNode[];
      } catch {
        incomingValues = null;
      }
    }

    this.valueNodes = this.buildValueTree(this.templateNodes, incomingValues);
    this.emitValues();
  }

  /**
   * Build a value tree aligned with the template tree.
   * If incoming values exist, reuse them by matching nodeId.
   */
  private buildValueTree(
    templates: TemplateNode[],
    incoming: CertificateValueNode[] | null
  ): CertificateValueNode[] {
    return templates.map(t => {
      const existing = incoming?.find(v => v.nodeId === t.id);
      const node: CertificateValueNode = {
        name: t.name,
        type: t.type,
        nodeId: t.id,
        value: existing?.value
      };

      if (t.children && t.children.length > 0) {
        node.children = this.buildValueTree(
          t.children,
          existing?.children ?? null
        );
      }
      else node.children = [];

      return node;
    });
  }

  onValueTreeChange() {
    this.emitValues();
  }

  private emitValues() {
    const json = JSON.stringify(this.valueNodes);
    this.valueJsonChange.emit(json);
  }
}